a.notification:hover {
   box-shadow: 0 5px 30px rgba(0, 0, 0, 0.18);
}
